<template>
    <div  
        style="border-bottom:1px solid #ddd; padding:10px" 
        @click="$emit('showCitation', data)"> 
        Citations
    </div>
</template>

<script>
export default {
    props: {
        citation: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            data: {}
        }
    },
    mounted() {
        this.isLoading = true;
        this.$store.dispatch("publicModule/onLoadModuleCitation", this.citation)
            .then( res => {
                this.data = res;
                this.isLoading = false;
            })
            .catch( err => {
                this.isLoading = false;
            });
    }
}
</script>

<style>

</style>
